// extracted by mini-css-extract-plugin
export default {"badgeEmoji":"BadgeEmoji_badgeEmoji__7ZEni","badgeEmojiCard":"BadgeEmoji_badgeEmojiCard__UNePo"};